module.exports = __webpack_public_path__ + "static/media/hprosChecked.718e0501.svg";